<template>
  <div>
    <mavon-editor
      ref="md"
      v-model="editorValue"
      :ishljs="true"
      :toolbars="toolbars"
      :subfield="subfield"
      :placeholder="placeholder"
      :code_style="code_style"
      :externalLink="externalLink"
      @imgAdd="$imgAdd"
      @imgDel="$imgDel"
      @fullScreen="$fullScreen"
      @change="onChange"
      :style="{ maxHeight: isFull ? '100%' : height }"
      :boxShadow="false"
    >
      <div slot="left-toolbar-after" class="uploadDiv">
        <a-upload
          listType="text"
          :multiple="true"
          :action="url.attachUpLoad"
          :headers="headers"
          :data="{ dataId: dataId }"
          :beforeUpload="beforeAttachUpload"
          @change="handleAttachChange"
          :showUploadList="false"
          :fileList="attachList"
        >
          <a-button
            icon="upload"
            class="op-icon fa"
            style="text-align:center;padding-left:7px"
            title="上传日志文件等附件"
            ></a-button>
        </a-upload>
      </div>
      <!-- <div slot="right-toolbar-after" class="helpDiv">
          <button
            title="markdown语法帮助"
            class="op-icon fa fa-mavon-question-circle"
            style="dispaly:inline-block;font-size:17px"
            @click="showHelp"
            ></button>
      </div> -->
    </mavon-editor>
    
  </div>
</template>

<script>
import mavonEditor from "mavon-editor";
import * as worksheet from "@/request/worksheet";
const File = model.File;
import { model, user, env } from "eco-cli";
const { getToken } = user

export default {
  name: "ComEditor",
  props: {
    value: {
      type: String,
      required: false,
    },
    dataId: {
      type: String,
      required: false,
    },
    toolbars: {
      type: Object,
      required: false,
      default: () => {
        return {
          bold: true, // 粗体
          italic: false, // 斜体
          header: true, // 标题
          underline: true, // 下划线
          strikethrough: true, // 中划线
          mark: true, // 标记
          superscript: false, // 上角标
          subscript: false, // 下角标
          quote: true, // 引用
          ol: true, // 有序列表
          ul: true, // 无序列表
          link: true, // 链接
          imagelink: true, // 图片链接
          code: true, // code
          table: false, // 表格
          fullscreen: true, // 全屏编辑
          readmodel: true, // 沉浸式阅读
          htmlcode: false, // 展示html源码
          help: false, // 帮助
          /* 1.3.5 */
          undo: false, // 上一步
          redo: false, // 下一步
          trash: false, // 清空
          save: false, // 保存（触发events中的save事件）
          /* 1.4.2 */
          navigation: true, // 导航目录
          /* 2.1.8 */
          alignleft: true, // 左对齐
          aligncenter: true, // 居中
          alignright: true, // 右对齐
          /* 2.2.1 */
          subfield: false, // 单双栏模式
          preview: true, // 预览
        };
      },
    },
    confirmLoading: {
      type: Boolean,
      required: false,
    },
    subfield: {
      type: Boolean,
      required: false,
      default: true,
    },
    height: {
      type: String,
      required: false,
      default: "500px",
    },
    placeholder: {
      type: String,
      required: false,
      default: "在此编辑回复。使用Markdown。可粘贴或拖拽图片",
    }
  },
  data() {
    return {
      isFull: false,
      isUpload: false,
      headers: {},
      url: {
        attachUpLoad: "/eco-worksheet-server/worksheet/attach/uploadFile",
      },
      attachList: [],
      code_style: 'solarized-dark',
      externalLink: {
        markdown_css: function() {
            // 这是你的markdown css文件路径
            // return 'highlight.js/styles/github-dark.css';
        },
      }
    };
  },
  created() {
    getToken().then((res)=> {
      this.isLogin = res ? true : false;
      this.headers = { "X-Access-Token": res };
    })
  },
  computed: {
    editorValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("change", v);
      },
    },
  },
  mounted() {

  },
  
  methods: {
    // 绑定@imgAdd event
    $imgAdd(pos, $file) {
      this.isUpload = true;
      this.$emit("update:confirmLoading", true);
      // 第一步.将图片上传到服务器.
      const formdata = new FormData();
      formdata.append("file", $file);
      formdata.append("dataId", this.dataId);
      worksheet
        .postImage(formdata)
        .then((res) => {
          this.$message.success("上传成功！");
          let newFile = File.fromServer(res);
          this.$refs.md.$img2Url(
            pos,
            newFile.url
          );
        })
        .finally(() => {
          this.isUpload = false;
          this.$emit("update:confirmLoading", false);
        });
    },
    $imgDel(pos) {},
    getHtml() {
      return this.$refs.md.d_render;
    },
    $fullScreen(status) {
      this.isFull = status;
      this.$emit("changeStatus", status);
    },
    onChange(v) {
      let spaceTabMatches = [];
      let backquoteMatches = [];
      let splitCodes = "";
      // 四个空格与tab生成的代码块
      spaceTabMatches = v.match(
          /(?<=((\n\n)|(^)|(`{1,3}\n)))((( {4})|( {0,3}	)).+\n)*(( {4})|( {0,3}	)).+(?=((\n)|($)))/  // eslint-disable-line
      );
      while (spaceTabMatches && spaceTabMatches.length > 0) {
        const startIndex = spaceTabMatches.index;
        const endIndex = spaceTabMatches.index + spaceTabMatches[0].length;
        if (startIndex > 0) {
          splitCodes = splitCodes + v.substring(0, startIndex);
        }
        splitCodes = splitCodes + spaceTabMatches[0].replace(/</g, "🙀");
        if (v.length === endIndex) {
          v = "";
        } else {
          v = v.substring(endIndex);
        }

        spaceTabMatches = v.match(
          /(?<=((\n\n)|(^)|(`{1,3}\n)))((( {4})|( {0,3}	)).+\n)*(( {4})|( {0,3}	)).+(?=((\n)|($)))/  // eslint-disable-line
        );
      }

      v = splitCodes + v;
      splitCodes = "";

      // 反引号生成的代码块
      backquoteMatches = v.match(/(?<=(^|\n))`+[\s\S]+?`+/);
      while (backquoteMatches && backquoteMatches.length > 0) {
        const startIndex = backquoteMatches.index;
        const endIndex = backquoteMatches.index + backquoteMatches[0].length;
        if (startIndex > 0) {
          splitCodes = splitCodes + v.substring(0, startIndex);
        }
        let matches = [];
        matches = backquoteMatches[0].match(/`+/g);
        if (
          matches &&
          (matches[0].length > 2 ||
            (matches[0].length === matches[1].length &&
              backquoteMatches[0].indexOf("\n\n") === -1))
        ) {
          splitCodes = splitCodes + backquoteMatches[0].replace(/</g, "🙀");
        } else {
          splitCodes = splitCodes + backquoteMatches[0];
        }
        if (v.length === endIndex) {
          v = "";
        } else {
          v = v.substring(endIndex);
        }
        matches = [];
        backquoteMatches = v.match(/(?<=(^|\n))`+[\s\S]+?`+/);
      }
      v = splitCodes + v;
      splitCodes = "";

      v = v.replace(/</g, "&lt;");
      v = v.replace(/🙀/g, "<");
      const downTags = v.match(/&lt;download id {0,30}= {0,30}\"[0-9a-zA-z]{20,40}\" {0,30}>[^<>\/\\:\*\?\"\|\&]+&lt;\/download>/g);  // eslint-disable-line

      if (downTags && downTags.length > 0) {
        downTags.forEach((element) => {
          const fileName = element.match(
            /(?<=&lt;download id {0,30}= {0,30}"[0-9a-zA-z]{20,40}" {0,30}>)[^<>/\\:\*\?"\|&]+(?=&lt;\/download>)/  // eslint-disable-line
          );
          const downloadId = element.match(
            /(?<=&lt;download id {0,30}= {0,30}")[0-9a-zA-z]{20,40}(?=" {0,30}>)/  // eslint-disable-line
          );
          v = v.replace(
            element,
            `<a href='${env.config().file_origin}eco-file-server/file/eco/download/${downloadId[0]}' target='_self'>${fileName[0]}</a>`
          );
        });
      }
      const customHtml = mavonEditor.markdownIt.render(v);
      this.$refs.md.d_render = customHtml;
    },
    beforeAttachUpload(file) {
      this.$emit("update:confirmLoading", true);
      if(file.type.indexOf('image/') > -1) {
        this.$message.warning('不支持上传图片类附件！')
        this.$emit("update:confirmLoading", false);
        return false
      }
      const isTooLarge = file.size / 1024 / 1024 > 30;
      if (isTooLarge) {
        this.$message.error(`单个附件不能超过30MB!`);
        this.$emit("update:confirmLoading", false);
      }
      return !isTooLarge;
    },
    handleAttachChange({ fileList }) {
      this.attachList = this.handleFilesChange(fileList);
    },
    /** 文件上传状态改变事件 */
    handleFilesChange(fileList) {
      let attachList = [...fileList];
      attachList = attachList.map((item) => {
        if (item.status === "done" && item.response) {
          const json = item.response;
          if (json.success) {
            item.fileId = json.result.fileId;
            item.fileName = json.result.fileName;
            item.dataId = json.result.dataId;
            item.downloadId = json.result.identifier;
            this.$refs.md.d_value += `<download id="${item.fileId}">${item.fileName}</download>`;
            this.$message.success(`${item.name} 上传成功!`);
            this.$emit("update:confirmLoading", false);
          } else {
            item.status = "error";
            this.$message.error(`${item.name} ${json.message}!`);
            this.$emit("update:confirmLoading", false);
          }
          delete item.response;
        } else if (item.status === "error" && item.response) {
          delete item.response;
          this.$message.error(`${item.name} 上传失败.`);
          this.$emit("update:confirmLoading", false);
        }
        return item;
      });
      const isAllDone = attachList.every((item) => {
        return (item.status === "done" || item.status === "error") && !item.response;
      });
      // 所有上传完
      if (isAllDone) {
        this.$emit("update:confirmLoading", false);
      }
      return attachList;
    },
    showHelp() {
      this.$emit('helpShow', true, this.$refs.md.d_help)
    }
  },
  model: {
    prop: "value",
    event: "change",
  },
};
</script>

<style lang="scss">
.fa-mavon-eye-slash {
  display: none !important;
}
.v-note-wrapper {
  min-height: 350px !important;
  z-index: 1!important;
}
.fa-mavon-eye {
  display: none !important;
}
.op-image.popup-dropdown {
  height: 80px !important;
  overflow: hidden !important;
}
.content-input-wrapper {
  min-height: 200px;
}
.markdown-body ul {
  list-style-type: disc!important;
}
.hljs-keyword {
  // color: #f92672!important;
}

@media screen and (max-width: 1400px) {
  .v-note-wrapper {
    min-height: 250px!important;
  }
}
.helpDiv {
  display: inline-block;
}
.uploadDiv {
  display: inline-block;
  margin-left: -12px!important;
  background: #fff!important;
  .anticon-upload {
    font-size: 15px;
  }
}

</style>
